import { Http, Response, Headers, RequestOptions } from '@angular/http';
// import 'rxjs/Rx';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

import { Observable, of } from 'rxjs';

export class BaseService {
    private isErrorOccured = false;
    private serviceCount = 0;
    private httpClient: HttpClient;
    constructor(private injector: Injector, protected baseURL: string) {
        this.httpClient = injector.get(HttpClient);
    }
    protected async getAsync(url: string, isNoLoadingPanel?: boolean): Promise<any> {
        try {
            const res = await this.httpClient.get(this.baseURL + url, this.getOptions(isNoLoadingPanel)).toPromise();
            this.hideLoadingPanel(isNoLoadingPanel);
            return res;
        } catch (err) {
            this.hideLoadingPanel(isNoLoadingPanel);
            console.error(err);
            return of('getAsync');
        }
    }

    protected async postSync(url: string, data: any, isNoLoadingPanel?: boolean): Promise<any> {
        try {
            const res = await this.httpClient.post(this.baseURL + url, JSON.stringify(data), this.getOptions(isNoLoadingPanel)).toPromise();
            this.hideLoadingPanel(isNoLoadingPanel);
            return res;
        } catch (err) {
            this.hideLoadingPanel(isNoLoadingPanel);
            console.error(err);
            return of('postSync');
        }
    }
    protected async putSync(url: string, data: any, isNoLoadingPanel?: boolean): Promise<any> {
        try {
            const res = await this.httpClient.put(this.baseURL + url, JSON.stringify(data), this.getOptions(isNoLoadingPanel)).toPromise();
            this.hideLoadingPanel(isNoLoadingPanel);
            return res;
        } catch (err) {
            this.hideLoadingPanel(isNoLoadingPanel);
            return of('putSync');
        }
    }
    protected async deleteSync(url: string, isNoLoadingPanel?: boolean): Promise<any> {
        try {
            const res = await this.httpClient.delete(this.baseURL + url, this.getOptions(isNoLoadingPanel)).toPromise();
            this.hideLoadingPanel(isNoLoadingPanel);
            return res;
        } catch (err) {
            this.hideLoadingPanel(isNoLoadingPanel);
            console.error(err);
            return of('deleteSync');
        }
    }

    protected get(url: string, isNoLoadingPanel?: boolean): any {
        return this.httpClient.get(this.baseURL + url, this.getOptions(isNoLoadingPanel))
            .pipe(
                tap(_ => { this.hideLoadingPanel(isNoLoadingPanel); }),
                catchError(this.handleError<any>('get'))
            );
    }

    protected post(url: string, data: any, isNoLoadingPanel?: boolean): any {
        return this.httpClient.post(this.baseURL + url, JSON.stringify(data), this.getOptions(isNoLoadingPanel))
            .pipe(
                tap(_ => { this.hideLoadingPanel(isNoLoadingPanel); }),
                catchError(this.handleError<any>('post'))
            );
    }
    protected put(url: string, data: any, isNoLoadingPanel?: boolean): any {
        return this.httpClient.put(this.baseURL + url, JSON.stringify(data), this.getOptions(isNoLoadingPanel))
            .pipe(
                tap(_ => { this.hideLoadingPanel(isNoLoadingPanel); }),
                catchError(this.handleError<any>('put'))
            );
    }
    protected delete(url: string, isNoLoadingPanel?: boolean): any {
        return this.httpClient.delete(this.baseURL + url, this.getOptions(isNoLoadingPanel))
            .pipe(
                tap(_ => { this.hideLoadingPanel(isNoLoadingPanel); }),
                catchError(this.handleError<any>('delete'))
            );
    }

    private getOptions(isNoLoadingPanel: boolean): any {
        this.showLoadingPanel(isNoLoadingPanel);
        const options: any = {};
        const token = localStorage.getItem('AuthToken');
        const headers = new HttpHeaders({ 'Content-Type': ['application/json'], 'Authorization': `Bearer ${token}` });
        options.headers = headers;
        return options;
    }

    private getOptionsForImage(isNoLoadingPanel: boolean): any {
        this.showLoadingPanel(isNoLoadingPanel);
        const options: any = {};
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({ 'session-id': [token] });
        options.headers = headers;
        return options;
    }

    protected uploadImage(url: string, data: any, isNoLoadingPanel?: boolean): any {
        return this.httpClient.post(this.baseURL + url, data, this.getOptionsForImage(isNoLoadingPanel))
            .pipe(
                tap(_ => { this.hideLoadingPanel(isNoLoadingPanel); }),
                catchError(this.handleError<any>('post'))
            );
    }

    private handleError<T>(operation = 'operation', result?: T) {
        this.hideLoadingPanel(false);

        return (error: any): Observable<T> => {

            if (error.status == 401) {
                localStorage.removeItem('token');
                const router: Router = this.injector.get(Router);
                router.navigate(['/login']);
            }

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.logError(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    public logError(errMsg: any) {
        // this.isErrorOccured = true;
        // var errInfo: any = {};
        // errInfo.message = errMsg.toString();
        // errInfo.type = "Error";
        // this.post('Log/LogError', errInfo).subscribe(status => {
        // 	this.isErrorOccured = false;
        // });
    }
    private showLoadingPanel(isNoLoadingPanel: boolean) {
        if (!isNoLoadingPanel) {
            this.serviceCount++;
            // jQuery('#loading-cloud').show();
        }
    }
    private hideLoadingPanel(isNoLoadingPanel: boolean) {
        if (!isNoLoadingPanel) {
            this.serviceCount--;
            if (this.serviceCount <= 0) {
                //  jQuery('#loading-cloud').hide();
            }
        }
    }
}
